import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContent = styled('div')(({ theme }) => ({
  width: 'calc(100% - 300px)',
  float: 'right',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    position: 'relative',
  },
}));

export const StyledHeaderButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  '& .MuiButton-startIcon': {
    marginRight: isMobile ? 0 : theme.spacing(1),
  },
  '& .btnText': {
    display: isMobile ? 'none' : 'block',
  },
}));
